<template>
  <div class="boxMessage">
    <div class="flex shortDescription">
      <div>
        <span class="bold">{{ $t("home_air_quality.aqi") }}</span>
        <span>Merilno mesto 786776, Bravničarjeva 13</span>
        <span>1000 Ljubjana</span>
      </div>
      <a class="icon" href="#"><i class="warpit_icon_dot_menu"></i></a>
    </div>
    <div class="content flex">
      <i class="warpit_icon_Home"></i>
      <div class="col1_3"></div>
      <div class="col2_3">
        <span class="bold">Normalno</span>
        <span
          >The air quality is good enough to do some shopping or go for a walk
          to the park.</span
        >
      </div>
    </div>
    <span class="when">Pred 3 dnevi</span>
  </div>
</template>

<script>
export default {
  name: "AirQuality",
};
</script>

<style scoped></style>
